import { render, staticRenderFns } from "./AdminContainer.vue?vue&type=template&id=19b2bc02&scoped=true"
import script from "./AdminContainer.vue?vue&type=script&lang=ts"
export * from "./AdminContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b2bc02",
  null
  
)

export default component.exports